import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Navbar from './component/Landing_page/Header/Navbar';
import Landing_Page from './component/Landing_page/Landing_Page';
import DashboardLayout from './component/Dashboard/DashboardLayout';
import Footer from './component/Landing_page/Footer/Footer';
import { useState } from 'react';

import PrivacyPolicy from './component/Landing_page/Policy & conditions/PrivacyPolicy';
import TandC from './component/Landing_page/Policy & conditions/Term_n_condition';
import ScrollToTop from './component/ScrollToTop';
import LoginPage from './component/Landing_page/Login/Loginpage';
import Registration from './component/Landing_page/Registration/Registrationpage';
import TermsAndConditions from './component/Landing_page/Policy & conditions/Term_n_condition';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false); 

  return (
    
    <Router>
         <ScrollToTop />
      <ConditionalWrapper>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing_Page />} />
          <Route path="/Sign_up" element={<Registration />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy/>} />
          <Route path="/terms_services" element={< TermsAndConditions/>} />
        
        
          <Route
            path="/Log_in"
            element={<LoginPage onLogin={() => setIsAuthenticated(true)} />} 
          />

          {/* Protected Dashboard Routes */}
          <Route
            path="/Dashboard_panel/*"
            element={
             
                <DashboardLayout />
              
            }
          />
        </Routes>
      </ConditionalWrapper>
    </Router>
  );
}

// Conditional Wrapper for Navbar and Footer
function ConditionalWrapper({ children }) {
  const location = useLocation();
  const excludeHeaderFooterPaths = ['/Dashboard_panel']; 

  const hideHeaderFooter = excludeHeaderFooterPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {!hideHeaderFooter && <Navbar />}
      {children}
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

export default App;
